const productsKeys = {
  module: ['products'] as const,
  list: () => [...productsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...productsKeys.list(), filters] as const,
  details: (id: string) => [...productsKeys.module, 'details', id] as const,
  sizeDetails: (productId: string, sizeId: string) => [
    ...productsKeys.module,
    productId,
    'sizes',
    sizeId,
  ],
  saleDetails: (productId: string, saleId: string) => [
    ...productsKeys.module,
    productId,
    'sales',
    saleId,
  ],
  additionalGroupConfigDetails: (
    productId: string,
    additionalGroupConfigId: string,
  ) => [
    ...productsKeys.module,
    productId,
    'additional-group-configs',
    additionalGroupConfigId,
  ],
  sales: (id: string) => [...productsKeys.module, 'sales', id] as const,
  ids: (productsIds: string[]) =>
    [...productsKeys.module, 'ids', ...productsIds] as const,
};

export default productsKeys;
